export enum PeriodicSalePeriodicity { Weekly = 7, Monthly = 30, ThreeMonths = 90, SixMonths = 180, Yearly = 365, Custom = -1 }